/**
 * UploadInspectionRequestViewModel
 * Combines data from UploadInspectionRequests and ScheduledTaskQueue tables
 * Used for system administrator UI to view upload inspection request status and related task queue data
 */
export class UploadInspectionRequestViewModel {
  // UploadInspectionRequest fields
  id: string;
  uploadId: string;
  requestedOn: Date;
  requestedByUserId: string;
  requestedByUserName: string;
  collectedOn: Date;
  scheduledInspectionId: string;
  workflowApplicationId: string;
  workflowApplicationActivityDataId: string;
  workflowVersionId: string;
  inspectionType: string;
  noScheduleInspection: boolean;
  formValuesJSON: string;
  attachmentsJSON: string;
  inspectorSignatureImageJSON: string;
  picSignatureImageJSON: string;
  applicationNumber: string;

  // ScheduledTaskQueue fields
  scheduledTaskQueueId: string;
  taskType: string;
  taskClass: string;
  scheduledTaskQueuedOn: Date;
  scheduledTaskExecutedOn: Date;
  scheduledTaskCompletedOn: Date;
  scheduledTaskErrorMessage: string;
  resultsJSON: string;
  processedApplicationUrl: string;

  // Status indicators
  requestStatus: string;
  hasError: boolean;
  daysSinceRequested: number;

  /**
   * Determines the current status of the request based on task completion and error states
   * @returns Status string: "Error", "Completed", "Executing", "Queued", "Collected", or "Pending"
   */
  getStatus(): string {
    if (this.scheduledTaskErrorMessage) {
      return 'Error';
    }
    if (this.scheduledTaskCompletedOn) {
      return 'Completed';
    }
    if (this.scheduledTaskExecutedOn) {
      return 'Executing';
    }
    if (this.scheduledTaskQueuedOn) {
      return 'Queued';
    }
    if (this.collectedOn) {
      return 'Collected';
    }
    return 'Pending';
  }
}

/**
 * Response wrapper for paginated upload inspection requests
 */
export class UploadInspectionRequestsResponse {
  items: UploadInspectionRequestViewModel[] = [];
  recordCount: number = 0;
  pageCount: number = 0;
}
